/* v88-links.js — TEMPORARY. Keeps a V88 preview on V88.
 *
 * The header, footer and every shared component link to the live pages
 * (/, /products/onefit, ...), so one click off a V88 template drops the
 * reviewer back into the current site. Until V88 ships, this rewrites those
 * links on V88 pages only to their ?view=v88* counterparts.
 *
 * Links are <a href> and one more: the cart drawer's line items (Renz,
 * Sep 29 — "the cart drawer redirects to without ?view"). Clicking an
 * item's photo or name there is not a link: fon-cart-drawer-v2.js reads the
 * row's data-url (the cart's /products/onefit?variant=...) and sets
 * location.href, so the <a> pass never saw it. Those rows get the same
 * rewrite. The drawer's other ways out go to /checkout and /collections/all,
 * which have no V88 page.
 *
 * Remove this file and its line in snippets/fon-scripts-header.liquid when
 * the V88 templates become the defaults — at that point the map below is a
 * no-op and the script is dead weight.
 */
(function () {
  'use strict';
  var MAP = {
    /* '/' is no longer mapped (2026-10-14, on request: "logo can be direct to
       https://usefon.com/"). The V88 home IS the plain home now, so the logo
       and every home link stay on /, not /?view=v88. */
    /* OneFit on V88 is V4.7 (Renz, Sep 29); Plant-Based keeps its own
       view on V4.6. A link naming a V4.6 variant is kept on V4.6 below. */
    '/products/onefit': '/products/onefit-v4-7',
    '/products/onefit-b': '/products/onefit-v4-7',
    '/products/onefit-v4-7': '/products/onefit-v4-7',
    '/products/onelife': '/products/onelife-aus',
    /* onelife-jar stays mapped: links elsewhere in the theme now point at
       onelife-aus, but anything out in the wild still names the jar. */
    '/products/onelife-jar': '/products/onelife-aus',
    '/products/onelife-aus': '/products/onelife-aus'
    /* TwoStrong is out of this map for now (2026-10-01, on request): the
       product serves product.twostrong as its own template, so a link to it
       needs no ?view=. Since 2026-10-21 that template IS the V88 page and
       product.v88-twostrong.json is gone; an old ?view=v88-twostrong link
       falls back to it. */
  };
  /* What carries a destination, and in which attribute. */
  var TARGETS = [
    ['a[href]', 'href'],
    ['.fon-line-item[data-url]', 'data-url']
  ];
  function rewrite(el, attr) {
    var href = el.getAttribute(attr);
    if (!href || /^(#|mailto:|tel:|javascript:)/i.test(href)) return;
    var url;
    try { url = new URL(href, location.origin); } catch (e) { return; }
    if (url.origin !== location.origin || url.searchParams.has('view')) return;
    /* A market subfolder (/en-us/products/onefit) keeps its prefix. */
    var path = url.pathname.replace(/\/+$/, '') || '/';
    var locale = '';
    var m = path.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(\/.*)?$/i);
    if (m && MAP[m[2] || '/']) { locale = m[1]; path = m[2] || '/'; }
    var to = MAP[path];
    if (!to) return;
    /* ...unless it names a V4.6 variant: a cart line's ?variant= or the
       announcement's ?flavour=<V4.6 SKU>. V4.7 does not have that variant,
       so it would open on a default instead. */
    if (path === '/products/onefit' && (url.searchParams.has('variant') || url.searchParams.has('flavour'))) {
      to = '/products/onefit?view=v88-onefit';
    }
    var next = new URL(to, location.origin);
    url.searchParams.forEach(function (v, k) { next.searchParams.set(k, v); });
    next.hash = url.hash;
    var out = (locale + next.pathname).replace(/\/+$/, '') || '/';
    if (out !== '/' && next.pathname === '/') out += '/';
    /* Only when it changes. '/products/onefit-v4-7' and '/products/onelife-aus'
       map to themselves with no view=, and setting an attribute to its own
       value is still a mutation: the observer below fired, rewrote, fired
       again, forever, freezing the tab ("Page Unresponsive") the moment the
       cart drawer drew a 4.7 line (2026-10-14, Renz: add to cart hangs). */
    var val = out + next.search + next.hash;
    if (val !== href) el.setAttribute(attr, val);
  }
  function run(root) {
    root = root || document;
    TARGETS.forEach(function (t) {
      if (root.matches && root.matches(t[0])) rewrite(root, t[1]);
      root.querySelectorAll(t[0]).forEach(function (el) { rewrite(el, t[1]); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  /* Menus and the drawer render late; catch what they add, and any link
     whose destination is changed in place. rewrite() writes only a value
     that differs, so this does not feed itself. */
  new MutationObserver(function (m) {
    m.forEach(function (r) {
      if (r.type === 'attributes') { run(r.target); return; }
      r.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'data-url'] });
})();
